import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileUploaderComponent } from './file-uploader.component';
import { FileUploaderDirective } from './file-uploader.directive';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { ZiroButtonComponent } from '../../button/button.component';
import { PipesModule } from '../pipes/pipes.module';
import { DatatableComponent } from '../tables/datatable/datatable.component';

@NgModule({
  declarations: [FileUploaderComponent, FileUploaderDirective],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    NgbTooltip,
    ZiroButtonComponent,
    PipesModule,
    DatatableComponent,
  ],
  exports: [FileUploaderComponent, FileUploaderDirective],
})
export class FileUploaderModule {}
